import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--dashboards--switch"
export default class extends Controller {
  static targets = [
    "radioSchedule",
    "radioStatistics",
    "statistics",
    "schedule"
  ]

  connect() {
    this.init()
  }

  init() {
    if (!this.radioScheduleTarget.checked && !this.radioStatisticsTarget.checked) {
      this.radioScheduleTarget.checked = true
    }

    // if (this.radioMainsTarget.checked) {
    //   this.mainsTarget.classList.remove("hidden")
    //   this.extrasTarget.classList.add("hidden")
    // } else {
    //   this.mainsTarget.classList.add("hidden")
    //   this.extrasTarget.classList.remove("hidden")
    // }
  }

  switch(event) {
    if (event.currentTarget.value === "statistics") {
      this.statisticsTarget.classList.remove("hidden")
      this.scheduleTarget.classList.add("hidden")
    } else {
      this.statisticsTarget.classList.add("hidden")
      this.scheduleTarget.classList.remove("hidden")
    }
  }
}
